// Schema markups and structured data helpers for SEO

export const localBusinessSchema = {
  "@type": "Plumber",
  "@id": "https://janhedegaard.dk/#localbusiness",
  "name": "Entreprenør Jan Hedegaard ApS",
  "alternateName": "Jan Hedegaard Kloakmester & Entreprenør",
  "legalName": "Entreprenør Jan Hedegaard ApS",
  "description": "Autoriseret kloakmester og entreprenør i Galten og omegn. Over 20 års erfaring med autoriseret kloakarbejde, kloakseparering, TV-inspektion, dræn, jord- og anlægsarbejde for private og erhverv.",
  "url": "https://janhedegaard.dk/",
  "telephone": "+45 22 45 85 67",
  "email": "jan@janhedegaard.dk",
  "image": "https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/43586154-92d6-43c8-8757-0c72ffc22dd7.jpg",
  "logo": "https://janhedegaard.dk/images/auxo_logo_black.png",
  "priceRange": "$$",
  "taxID": "DK45789942",
  "vatID": "DK45789942",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Søballevej 31",
    "addressLocality": "Galten",
    "postalCode": "8464",
    "addressCountry": "DK"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 56.1558,
    "longitude": 9.9056
  },
  "areaServed": [
    { "@type": "AdministrativeArea", "name": "Galten" },
    { "@type": "AdministrativeArea", "name": "Skanderborg" },
    { "@type": "AdministrativeArea", "name": "Aarhus" },
    { "@type": "AdministrativeArea", "name": "Silkeborg" },
    { "@type": "AdministrativeArea", "name": "Ry" },
    { "@type": "AdministrativeArea", "name": "Østjylland" }
  ],
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "07:00",
      "closes": "16:00"
    }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Kloak- og entreprenørydelser",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Kloakmesterarbejde",
          "url": "https://janhedegaard.dk/kloakmester-arbejde"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Kloakseparering",
          "url": "https://janhedegaard.dk/kloakseparering"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Kloakservice",
          "url": "https://janhedegaard.dk/kloakservice"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "TV-inspektion",
          "url": "https://janhedegaard.dk/tv-inspektion"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Entreprenørarbejde",
          "url": "https://janhedegaard.dk/entreprenoerarbejde"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Anlæg og belægning",
          "url": "https://janhedegaard.dk/anlaeg-og-belaegning"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Støbning af beton",
          "url": "https://janhedegaard.dk/stoebning-af-beton"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Haveservice & Træfældning",
          "url": "https://janhedegaard.dk/haveservice"
        }
      }
    ]
  }
};

export const createBreadcrumbSchema = (items) => {
  return {
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      ...(item.url ? { "item": item.url } : {})
    }))
  };
};

export const createServiceSchema = ({ name, description, url, image, serviceType = "Kloakarbejde" }) => {
  return {
    "@type": "Service",
    "name": name,
    "serviceType": serviceType,
    "description": description,
    "provider": {
      "@id": "https://janhedegaard.dk/#localbusiness"
    },
    "areaServed": [
      { "@type": "AdministrativeArea", "name": "Galten" },
      { "@type": "AdministrativeArea", "name": "Skanderborg" },
      { "@type": "AdministrativeArea", "name": "Aarhus" },
      { "@type": "AdministrativeArea", "name": "Østjylland" }
    ],
    ...(url ? { "url": url } : {}),
    ...(image ? { "image": image } : {})
  };
};

export const websiteSchema = {
  "@type": "WebSite",
  "@id": "https://janhedegaard.dk/#website",
  "url": "https://janhedegaard.dk/",
  "name": "Entreprenør Jan Hedegaard ApS",
  "alternateName": "Jan Hedegaard - Autoriseret Kloakmester & Entreprenør",
  "description": "Autoriseret kloakmester og entreprenør i Galten og omegn. Over 20 års erfaring med autoriseret kloakarbejde, TV-inspektion og kloakseparering.",
  "inLanguage": "da-DK",
  "publisher": {
    "@id": "https://janhedegaard.dk/#localbusiness"
  }
};

export const createContactPageSchema = () => {
  return {
    "@type": "ContactPage",
    "@id": "https://janhedegaard.dk/kontakt#webpage",
    "url": "https://janhedegaard.dk/kontakt",
    "name": "Kontakt Entreprenør Jan Hedegaard | Kloakmester & Entreprenør i Galten",
    "description": "Kontakt Jan Hedegaard for et uforpligtende tilbud på kloakarbejde, kloakseparering, TV-inspektion eller entreprenørarbejde.",
    "inLanguage": "da-DK",
    "isPartOf": {
      "@id": "https://janhedegaard.dk/#website"
    },
    "mainEntity": {
      "@type": "ContactPoint",
      "telephone": "+45 22 45 85 67",
      "email": "jan@janhedegaard.dk",
      "contactType": "customer service",
      "areaServed": ["Galten", "Skanderborg", "Aarhus", "Silkeborg", "Østjylland"],
      "availableLanguage": "Danish",
      "hoursAvailable": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "07:00",
        "closes": "16:00"
      }
    }
  };
};

export const createAboutPageSchema = () => {
  return {
    "@type": "AboutPage",
    "@id": "https://janhedegaard.dk/om-os#webpage",
    "url": "https://janhedegaard.dk/om-os",
    "name": "Om Jan Hedegaard | Autoriseret Kloakmester i Galten",
    "description": "Læs om Entreprenør Jan Hedegaard. Over 20 års erfaring med autoriseret kloakarbejde og entreprenøropgaver i Galten og omegn.",
    "inLanguage": "da-DK",
    "isPartOf": {
      "@id": "https://janhedegaard.dk/#website"
    },
    "about": {
      "@id": "https://janhedegaard.dk/#localbusiness"
    }
  };
};

export const createImageGallerySchema = ({ items = [] } = {}) => {
  const imageElements = items.slice(0, 30).map((item, index) => ({
    "@type": "ImageObject",
    "position": index + 1,
    "name": item.alt || item.title || "Udført arbejde af Entreprenør Jan Hedegaard",
    "contentUrl": item.src || item.image,
    "caption": item.alt || item.title || "Entreprenør- og kloakarbejde i Galten og Østjylland"
  }));

  return {
    "@type": "ImageGallery",
    "@id": "https://janhedegaard.dk/galleri#imagegallery",
    "url": "https://janhedegaard.dk/galleri",
    "name": "Billedgalleri - Tidligere udført kloak- og entreprenørarbejde | Jan Hedegaard",
    "description": "Se eksempler på tidligere udført kloakarbejde, kloakseparering, belægning, støbning og haveservice i Galten og omegn.",
    "inLanguage": "da-DK",
    "isPartOf": {
      "@id": "https://janhedegaard.dk/#website"
    },
    ...(imageElements.length > 0 ? { "image": imageElements } : {})
  };
};

